import { AxiosProvider } from '../AxiosProvider'
import { ApiCatalogSearchRequest, ApiCatalogSearchResponse } from './types'
import { env } from '../../env'

export class ApiClientCatalog {

  constructor(private provider: AxiosProvider) {}

  async search(request: ApiCatalogSearchRequest): Promise<ApiCatalogSearchResponse> {
    return this.provider.request({
      baseURL: env.REACT_APP_BACKEND_API_URL,
      url: '/api/v1/catalog/search',
      method: 'post',
      data: request,
    })
  }
}
